/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIntegration = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zM8 11c-.512 0-.935.387-.993.883L7 12v1H4v7h7v-1.171l-.012-.004a3.003 3.003 0 0 1-1.983-2.649L9 16c0-1.236.749-2.298 1.817-2.758L11 13.17V13H9v-1a1 1 0 0 0-1-1zm5 4h-1a1 1 0 0 0-.117 1.993L12 17h1v3h7v-7h-1.171l-.004.012a3.003 3.003 0 0 1-2.649 1.983L16 15a3.002 3.002 0 0 1-2.758-1.817L13.17 13H13zm7-11h-7v1.17l.012.005a3.003 3.003 0 0 1 1.983 2.649L15 8a3.002 3.002 0 0 1-1.817 2.758l-.183.071V11h2v1a1 1 0 0 0 1.993.117L17 12v-1h3zm-9 0H4v7h1.17l.005-.012a3.003 3.003 0 0 1 2.649-1.983L8 9c1.236 0 2.298.749 2.758 1.817l.071.183H11V9h1a1 1 0 0 0 .117-1.993L12 7h-1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgIntegration as Integration };
